/**
 * Backend UserRoleType enum ile uyumlu (euas-backend)
 */
export enum UserRoleType {
    EDUCATION_MANAGER = 0,
    CENTRAL_MANAGER = 1,
    BRANCH_MANAGER = 2,
    USER = 3,
    INSTRUCTOR = 4,
    INTERN = 5,
    EDUCATION_SUPERVISOR = 6,
    INTERN_SUPERVISOR = 7,
}

/**
 * Yönetici girişi yapabilen user type'lar (numara ile)
 * Bu listeye dahil olmayan (örn. USER=3) yönetici sayfasından giriş yapamaz
 */
export const ADMIN_LOGIN_ALLOWED_USER_TYPES: number[] = [
    UserRoleType.EDUCATION_MANAGER, // 0
    UserRoleType.CENTRAL_MANAGER, // 1
    UserRoleType.BRANCH_MANAGER, // 2
    UserRoleType.INSTRUCTOR, // 4
    UserRoleType.EDUCATION_SUPERVISOR, // 6
    UserRoleType.INTERN_SUPERVISOR, // 7
]

/** Yönetici login path */
export const ROUTES = {
    LOGIN_USER: "/login",
    LOGIN_ADMIN: "/admin/login",
    DASHBOARD_USER: "/dashboard",
    DASHBOARD_ADMIN: "/admin",
} as const

/** User type'ın admin girişine yetkili olup olmadığını kontrol et */
export const isAdminLoginAllowed = (userType: number): boolean =>
    ADMIN_LOGIN_ALLOWED_USER_TYPES.includes(userType)
